import React from "react";
import TailoredRestaurants from "../../assets/tailored_for_restaurants.webp";
import FastFood from "../../assets/fast_food_chains.webp";
import OfflineStores from "../../assets/offline_stores.webp";
import Large from "../../assets/large_online_offline_businesses.webp";

const FourCards = () => {
  return (
    <div className="container text-center mt-5 mb-5">
      <h2 className="text-center fw-bold " 
      style={{ color: "#444444", fontSize:"28px" }}>
        Businesses That Can Benefit from Packky</h2>
      <p className="fs-5 mt-4">Smart Deliveries, Satisfied Customers</p>

      <div className="container mt-5">
        <div className="row row-cols-1 row-cols-md-2 g-4">
          <div className="col d-flex justify-content-center">
            <div
              className="card new gradient blue w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div className="card-body-forradius" style={{ flex: 1 }}>
                <h4 className="card-title25 text-start fs-4 fw-bold ">
                Retail Stores & General Shops
                </h4>
                <p className="card-text text-secondary mr-5 mt-0 text-start fs-5 mb-3">
                Send goods to customers or restock branches quickly without owning a fleet.
                </p>
              </div>
              <img
                src={TailoredRestaurants}
                className="card-img-bottom"
                alt="..."
              />
            </div>
          </div>

          <div className="col d-flex justify-content-center">
            <div
              className="card new gradient green w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div
                className="card-body-forradius text-start align-items-start"
                style={{ flex: 1 }}
              >
                <h5 className="card-title25 text-start fs-4 fw-bold">Distributors & Wholesalers</h5>
                <p className="card-text text-secondary mr-5 text-start fs-5 mt-0 mb-3">
                Deliver bulk shipments to retailers with real-time tracking 
                and reliability.
                </p>
              </div>
              <img src={FastFood} className="card-img-bottom" alt="..." />
            </div>
          </div>

          <div className="col d-flex justify-content-center">
            <div
              className="card new gradient-yellow w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div
                className="card-body-forradius d-flex flex-column align-items-start text-start"
                style={{ flex: 1 }}
              >
                <h5 className="card-title25 mr-5 fs-4 fw-bold">E-commerce Sellers</h5>
                <p className="card-text text-secondary mr-5 text-start fs-5 mt-0 mb-3">
                Manage customer deliveries and returns directly from your warehouse.
                </p>
              </div>
              <img src={OfflineStores} className="card-img-bottom" alt="..." />
            </div>
          </div>

          <div className="col d-flex justify-content-center">
            <div
              className="card new gradient purple w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div className="card-body-forradius" style={{ flex: 1 }}>
                <h5 className="card-title25 text-start fs-4 fw-bold mr-5">
                Large & Multi-Location Businesses
                </h5>
                <p className="card-text text-secondary text-start mr-5 fs-5 mt-0 mb-3">
                Streamline deliveries across multiple stores, franchises, or corporate clients.
                </p>
              </div>
              <img src={Large} className="card-img-bottom" alt="..." />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FourCards;
